<!--
 * @Description 合同详情-付款tab
-->
<template>
  <div
    v-loading="loading"
    v-empty="nopermission"
    class="rc-cont"
    xs-empty-icon="nopermission"
    xs-empty-text="暂无权限">
    <el-table
      v-show="fieldList.length > 0"
      :data="list"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      stripe
      @row-click="handleRowClick">
      <el-table-column
        v-for="(item, index) in fieldList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip />
    </el-table>
    <div class="tips">
      {{totalTips}}
    </div>
  </div>
</template>

<script type="text/javascript">
import {
  crmPaymentInfo
} from '@/api/crm/contract'

import { beautifyThePrice } from '@lhb/func'

export default {
  name: 'RelativePayment', // 付款相关
  components: {
    CRMFullScreenDetail: () => import('@/components/CRMFullScreenDetail'),
  },
  mixins: [],
  props: {
    id: [String, Number]
  },
  data() {
    return {
      loading: false,
      nopermission: false,
      list: [],
      fieldList: [],
      tableHeight: '400px',
      totalThirdFee: 0,
      totalOtherFee: 0
    }
  },
  computed: {
    totalTips() {
      const thirdFee = beautifyThePrice(this.totalThirdFee);
      const otherFee = beautifyThePrice(this.totalOtherFee);
      return `共${this.list.length}条付款记录，合计第三方实付金额${thirdFee}元，他项支付金额${otherFee}元`
    }
  },
  watch: {
  },
  mounted() {
    this.getDetail()
  },
  methods: {

    /**
     * 表头数据
     */
    getFieldList() {
      this.fieldList.push({ prop: 'num', label: '付款编号', width: 300 })
      this.fieldList.push({ prop: 'typeName', label: '付款类型' })
      this.fieldList.push({ prop: 'money', label: '付款金额' })
      this.fieldList.push({ prop: 'payDate', label: '付款日期' })
      this.fieldList.push({ prop: 'statusName', label: '付款状态' })
    },

    /**
     * 获取数据
     */
    getDetail(loading = true) {
      if (this.fieldList.length == 0) {
        this.getFieldList()
      }
      this.loading = loading
      crmPaymentInfo({id: this.id}).then((res) => {
        const { data = {} } = res;
        this.list = data.list || [];
        this.totalThirdFee = data.extraData?.thirdPartFee || 0;
        this.totalOtherFee = data.extraData?.publicRelationFee || 0;
        this.loading = false;
      })
    },

    /**
     * 当某一行被点击时会触发该事件
     */
    handleRowClick(row, column, event) {
      if (column.property == 'num') {
        this.$router.push(`/lhb-micro-pms/paymentRecord/detail?recordId=${row.paymentId}`)
      }
    },

    /**
     * 通过回调控制class
     */
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'num') {
        return 'can-visit--underline'
      } else {
        return ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/relativecrm.scss";
.tips {
  color: #909399;
  width: 100%;
  text-align: right;
  margin-top: 10px;
}
</style>
